<template>
    <div id="secret">
        <br>
        ありがとうございました。
        <br>
        PWは 「{{ key }}」です。
        <br>
        <br>
        <router-link :to="{ name: 'pay-select' }">ログイン画面</router-link>に戻ってご利用を開始してください。
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    created() {
        this.canView()
    },
    methods: {
        async canView() {
            let token = this.$route.query['token']
            await this.$store.dispatch('auth/canViewSecret', token)

            this.handle()
        },
        handle() {
            // (key == null) = 閲覧不可
            if (this.key === null) {
                this.$router.push({ name: 'pay-select' })
            }
        }
    },
    computed: {
        ...mapState({
            key: state => state.auth.authKey
        })
    }
}
</script>

<style scoped>
#secret {
    text-align: center;
}
</style>